import { render } from "./modal_comptabilisationvente.vue?vue&type=template&id=65e5706e&scoped=true"
import script from "./modal_comptabilisationvente.vue?vue&type=script&lang=js"
export * from "./modal_comptabilisationvente.vue?vue&type=script&lang=js"

import "./modal_comptabilisationvente.vue?vue&type=style&index=0&id=65e5706e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e5706e"]])

export default __exports__